import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

const Lock = ({
  color = 'icon.primary',
  stroke = '1.5',
  fill = 'transparent',
  ...props
}) => (
  <IconBase viewBox='0 0 12 14' {...props}>
    <Path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 13H2.33333C1.59667 13 1 12.4033 1 11.6667V6.33333C1
         5.59667 1.59667 5 2.33333 5H9C9.73667 5 10.3333 5.59667 10.3333
          6.33333V11.6667C10.3333 12.4033 9.73667 13 9 13Z'
      stroke={color}
      fill={fill}
      strokeWidth={stroke}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M5.66536 10.3932V8.6665'
      stroke={color}
      fill={fill}
      strokeWidth={stroke}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M6.02152 7.81295C6.21678 8.00821 6.21678 8.3248 6.02152
         8.52006C5.82626 8.71532 5.50968 8.71532 5.31442 8.52006C5.11915
          8.3248 5.11915 8.00821 5.31442 7.81295C5.50968 7.61769 5.82626
           7.61769 6.02152 7.81295'
      stroke={color}
      fill={fill}
      strokeWidth={stroke}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M3 5V3.66667V3.66667C3 2.194 4.194 1 5.66667 1V1C7.13933
         1 8.33333 2.194 8.33333 3.66667V3.66667V5'
      stroke={color}
      fill={fill}
      strokeWidth={stroke}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </IconBase>
)

Lock.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  stroke: PropTypes.string,
}

export default Lock
